import { autoinject } from 'aurelia-framework';
import { QueryFilter } from 'lib/tables/DataFilter';
import { PenBracketTypeDto } from 'models/pen/PenBracketType';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class PenBracketTypeService extends BaseApiService<PenBracketTypeDto> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, PenBracketTypeDto);
  }

  async getPenDesignTypes(filters: QueryFilter) {
    return await this.httpClient.execWithResponseMeta<PenBracketTypeDto[]>(`api/pen-bracket-type/list${filters.asQueryString}`, {
      method: 'GET',
    });
  }
}
